import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { choice_array, formArrayItem } from '../preview-forms.interface';
import { isChoiceFull } from 'src/app/shareds/utils/quota.util';


@Component({
    selector: 'app-form-dropdown',
    templateUrl: './form-dropdown.component.html',
    styleUrls: ['./form-dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormDropdownComponent {
  value: string = ""
  form!: formArrayItem;
  @Input('model') set item(v: formArrayItem) {
    this.form = v;
    if (this.form?.choices_value) this.setValue();
  }

  @Output('update') update = new EventEmitter()
  @Output('valid') valid = new EventEmitter()

  setValue() {
    this.value = this.form?.choices_value[0]?.question_choice_id
  }

  /** ตัวเลือกที่ใช้แสดงใน p-select — เติม _full ให้แต่ละตัวเลือก (ตัวที่เลือกอยู่แล้วไม่ถือว่าเต็ม กันแก้คำตอบเดิมไม่ได้) */
  get dropdownOptions(): any[] {
    return (this.form?.choices || []).map(c => ({ ...c, _full: isChoiceFull(c) && c.question_choice_id !== this.value }));
  }

  private emit() {
    const item: choice_array = { question_choice_id: this.value }
    this.update.emit([item])
    this.valid.emit(this.value ? false : true)
  }

  onChange() {
    if (this.form?.view) return
    this.emit()
  }
}
